import { render, staticRenderFns } from "./TextPink.vue?vue&type=template&id=4695ce48"
import script from "./TextPink.vue?vue&type=script&lang=js"
export * from "./TextPink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports